import React, { useState, useEffect } from 'react';
import { SVBCard, SVBTypography, SVBPagination } from '@svb/svb-react-components';
import { Link } from 'react-router-dom';
import { slugCreator } from '../../../core/useStore';

export default function SVBFaqFilter(props) {
  const [mounted, setMounted] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const sub_Heading_Faqs = 'Filtered By';
  const postPerpage = 10;
  const indexOfLastPage = currentPage * postPerpage;
  const indexOfFirstPage = indexOfLastPage - postPerpage;
  const data = props?.filterArray?.slice(indexOfFirstPage, indexOfLastPage);
  const totalPage = props?.filterArray?.length;
  const totalPerpage = Math.ceil(totalPage / postPerpage);
  const setPaginate = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <></>;
  }
  return (
    <>
      <div className='col-md-12 col-sm-12 pt-4 pb-4'>
        <SVBTypography type='heading-large' variant='heading-medium'>
          {sub_Heading_Faqs} : {props.filterKeys}
        </SVBTypography>
      </div>
      {data?.map((faqData, i) => {
        let faq_tags = [];
        faqData?.tags?.filter(
          (item) =>
            item.name !== 'common' &&
            item.value &&
            faq_tags.push({ label: item.value, type: 'faq' }),
        );
        return (
          <div
            className='col-md-6 col-sm-6 pb-4'
            role='button'
            key={i}
            data-testid={slugCreator(faqData?.title)}
          >
            <Link
              to={`/faqs/${slugCreator(faqData?.title)}`}
              state={{
                folder: faqData?.document_location,
              }}
            >
              <SVBCard
                title={faqData.title}
                description={faqData.description}
                categories={{
                  tagsPosition: 'footer',
                  extraClasses: 'me-2',
                  tags: faq_tags,
                }}
              ></SVBCard>
            </Link>
          </div>
        );
      })}
      <div className='pb-4 pt-4'>
        <SVBPagination
          totalPages={totalPerpage}
          currentPage={currentPage}
          setCurrentPage={setPaginate}
          extraClasses='d-flex justify-content-end'
        />
      </div>
    </>
  );
}
